import appApi from '../../../../../api/app-api';
import { ScholarshipReportDb } from '../../../../../api/types/reports/accountant/scholarship-report.type';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { StudentScholarshipsStatus } from '../../../../../api/types/students/student-scholarships/student-scholarship-entity';

export interface ScholarshipReportFilters {
  scholarshipSumStart: number | null;
  scholarshipSumEnd: number | null;
  createdAtStart: Date | null;
  createdAtEnd: Date | null;
  statuses: string[];
}

export const getScholarshipReportOperation = async (
  filters: ScholarshipReportFilters,
  offset: number,
  limit: number,
  setData: (data: ScholarshipReportDb[]) => any,
  setTotal: (total: number) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);

    const allStatuses = Object.values(
      StudentScholarshipsStatus,
    ) as StudentScholarshipsStatus[];

    const statusesToSend =
      filters.statuses && filters.statuses.length > 0
        ? filters.statuses
        : (allStatuses as string[]);

    const res = await appApi.getStudentScholarshipsReport({
      scholarshipSumStart: filters.scholarshipSumStart,
      scholarshipSumEnd: filters.scholarshipSumEnd,
      createdAtStart: filters.createdAtStart
        ? filters.createdAtStart.toISOString()
        : null,
      createdAtEnd: filters.createdAtEnd
        ? filters.createdAtEnd.toISOString()
        : null,
      offset,
      limit,
      statuses: statusesToSend,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    const paginationResponse = res.data.body;

    if (!paginationResponse || !Array.isArray(paginationResponse.data)) {
      console.error(
        'Invalid data in scholarship pagination response:',
        paginationResponse,
      );
      setData([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    setData(paginationResponse.data);
    const totalCount = paginationResponse.total ?? 0;
    setTotal(totalCount);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
